
    import { Injectable }       from '@angular/core';
    import { CanActivate, Router,ActivatedRouteSnapshot,RouterStateSnapshot } from '@angular/router';
    import { UsersService } from './users.service';
    import { Role } from '../app.constant';

    @Injectable()
    export class AuthGuard implements CanActivate {
      constructor(
          private usersService: UsersService,
         private router: Router
        ) {}
     
        ROLE: any = Role;

        canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;
        return this.checkLogin(url,route.data.role);
      }
     
      checkLogin(url: string,role_id:number): boolean {
        this.usersService.checkSingin()
        .subscribe((res: Response) => {
            if(res["fuel_status"] == "NG"){
              return false;
            }else{
              if(res["fuel_results"] != null){
                this.usersService.regUserInfo(res["fuel_results"]);
                if (this.ROLE.SYSTEM != this.usersService.userinfo.role_id) {

                  if (role_id != this.usersService.userinfo.role_id){
                  if (this.ROLE.ADMIN == this.usersService.userinfo.role_id){
                    this.router.navigate(["/admin"]);
                  }else if (this.ROLE.SYSTEM == this.usersService.userinfo.role_id){
                      this.router.navigate(["/system"]);
                  }else{
                      this.router.navigate(["/home"]);
                    }
                  }
                }
              }
              return true;
            }
          },error => {
            // console.log("fail:"+error);
            return false;
          });
        if (this.usersService.checkSingin()) { return true; }
       }

    }




// WEBPACK FOOTER //
// ./src/app/service/auth.guard.ts